"use client";

import { type ReactNode, Suspense } from "react";
import { GoogleAnalytics } from "../google";
import { keys } from "../keys";
import { SpeedInsights } from "../speed-insights";
import { VercelAnalytics } from "../vercel";
import { useHasConsent } from "./hooks/use-consent";
import { PostHogPageView } from "./integrations/page-view";
import { ConsentAwarePostHogProvider } from "./integrations/posthog";

type ConsentAwareAnalyticsProviderProps = {
  readonly children: ReactNode;
};

const { NEXT_PUBLIC_GA_MEASUREMENT_ID } = keys();

export const ConsentAwareAnalyticsProvider = ({
  children
}: ConsentAwareAnalyticsProviderProps) => {
  const hasMeasurementConsent = useHasConsent("measurement");

  return (
    <ConsentAwarePostHogProvider>
      <Suspense fallback={null}>
        <PostHogPageView />
      </Suspense>
      {children}
      {hasMeasurementConsent && <SpeedInsights />}
      {hasMeasurementConsent && <VercelAnalytics />}
      {hasMeasurementConsent && NEXT_PUBLIC_GA_MEASUREMENT_ID && (
        <GoogleAnalytics gaId={NEXT_PUBLIC_GA_MEASUREMENT_ID} />
      )}
    </ConsentAwarePostHogProvider>
  );
};
